<h1>DM Switch Calc Mortgage monthly payment (P&I)</h1>
<div class="d-flex" style="gap: 10px">
    <button (click)="dmResponse('failed')" type="button" class="btn btn-primary">DM Response Fail</button>
    <button (click)="dmResponse('success')" type="button" class="btn btn-primary">DM Response Pass</button>
</div>